const api = process.env.URL_API || 'https://api.staging.planbacademia.com';
// const api = 'http://localhost:4000';
export const url_auth = `${api}/user`;
export const url_gql = `${api}/graphql`;
